import React from 'react';
import './App.css';
import Profile from './components/profileComponent';

function App() {
  return (
    <div className="App">
      <header className="App-header">
      </header>
        <Profile></Profile>
    </div>
  );
}

export default App;
